export const removeDefaultStemmer = false;
export { default as Mark } from "/home/webb/WebstormProjects/file-manager-docs/node_modules/mark.js/dist/mark.js"
export const searchResultContextMaxLength = 50;
export const explicitSearchResultPath = true;
export const searchBarShortcut = true;
export const searchBarShortcutHint = true;
export const searchBarShortcutKeymap = "mod+k";
export const searchBarPosition = "right";
export const docsPluginIdForPreferredVersion = undefined;
export const indexDocs = true;
export const searchContextByPaths = null;
export const hideSearchBarWithNoSearchContext = false;
export const useAllContextsWithNoSearchContext = false;
export const askAi = null;